import { useState, useEffect } from 'react'
import { get } from 'aws-amplify/api'

import { AlertsHistory } from 'types/Alert'
import { getCachedAuthSession } from 'services/authSessionCache'

const useServerlessActiveAlerts = (
  deviceId: string,
  hasAlerts: boolean
) => {
  const [activeAlerts, setActiveAlerts] = useState<AlertsHistory | null>(null)
  const [areActiveAlertsLoaded, setAreActiveAlertsLoaded] = useState(false)

  useEffect(() => {
    if (!hasAlerts) {
      setActiveAlerts(null)
      setAreActiveAlertsLoaded(true)
    } else {
      (async () => {
        setAreActiveAlertsLoaded(false)
        const session = await getCachedAuthSession()

        try {
          const res = await get({
            apiName: 'dwaApi',
            path: `/active-alarms/${deviceId}`,
            options: {
              headers: { 'Authorization': session?.tokens?.idToken?.toString() || '' }
            }
          }).response

          const activeAlerts = await res.body.json()
          setActiveAlerts(activeAlerts as unknown as AlertsHistory)
        } catch (_error) { // eslint-disable-line @typescript-eslint/no-unused-vars
          setActiveAlerts(null)
        } finally {
          setAreActiveAlertsLoaded(true)
        }
      })()
    }
  }, [deviceId, hasAlerts])

  return {
    activeAlerts,
    areActiveAlertsLoaded
  }
}

export default useServerlessActiveAlerts
